import { NgModule } from '@angular/core';
import { SortArrayPipe } from './sort-array.pipe';

/**
 * A module containing objects associated with the sort array pipe
 */

export class SortArrayPipeModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    SortArrayPipe
  ],
  exports: [
    SortArrayPipe
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
